/**
 * useOrganizationEnrich
 *
 * Module-level singleton for opening OrganizationEnrichModal from anywhere.
 * The modal itself is mounted once in App.vue. Callers invoke open() with
 * a name + optional domain (used to seed Harmonic enrichment) and an
 * onCreated callback.
 */
import { ref, shallowRef } from "vue"
/** An organization as the enrich modal hands it back — a search hit or a created
 *  record narrowed to what callers read. `sources` is carried through
 *  (EventResource.mirrorToPipedrive reads it). */
export interface OrganizationRef {
  id: number
  name: string
  type?: string
  slug?: string
  sources?: { source_type: string; source_id: string }[]
}

export interface OrganizationEnrichOptions {
  name?: string
  domain?: string
  onCreated?: (record: OrganizationRef) => void
}

const show = ref(false)
const options = shallowRef<OrganizationEnrichOptions>({})

export function useOrganizationEnrich() {
  function open(opts: OrganizationEnrichOptions = {}) {
    options.value = opts
    show.value = true
  }

  function created(record: OrganizationRef) {
    options.value.onCreated?.(record)
    close()
  }

  function close() {
    show.value = false
    options.value = {}
  }

  return { show, options, open, created, close }
}
